import React, { useEffect, useState } from 'react'
import FolhaArrastavel from './FolhaArrastavel'
import { corAlerta, rotuloAlerta } from '../design/tiposAlerta'

// Janela de alertas do dashboard: lista (e-mails de alerta + alertas de conducao) e, ao tocar num item, o detalhe, que entra deslizando pela direita
// (voltar traz a lista pela esquerda). Abrir um alerta marca como lido.
const fmtHora = (d: string) => (d ? new Date(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—')
interface Props {
  aberta: boolean; aoFechar: () => void; alertas: any[]; naoLidos: number; abrirNoAlerta?: any
  aoLer: (al: any) => Promise<void> | void; aoLerTodos: () => Promise<void> | void
}

// conteudo da janela (so apresentacao: o estado fica em AlertasFolha; tambem usado na pre-visualizacao do visual)
interface ConteudoProps { alertas: any[]; naoLidos: number; atual: any; dir: 'avanca' | 'volta'; abrir: (al: any) => void; voltar: () => void; aoFechar: () => void; aoLerTodos: () => void }
export function ConteudoAlertas({ alertas, naoLidos, atual, dir, abrir, voltar, aoFechar, aoLerTodos }: ConteudoProps) {
  return (
    <>
      {!atual ? (
        <div key="lista" className={`db-vista ${dir}`} style={{ display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
            <h3 style={{ margin: 0, fontSize: '1.3rem', letterSpacing: '-.02em' }}>Alertas</h3>
            <div style={{ display: 'flex', gap: '.5rem' }}>
              {naoLidos > 0 && <button className="db-btn press" type="button" onClick={() => aoLerTodos()}>Marcar todos como lidos</button>}
              <button className="db-btn press" type="button" onClick={aoFechar}>Fechar</button>
            </div>
          </div>
          <p className="db-mini" style={{ margin: '.3rem 0 .6rem' }}>{naoLidos} não lido(s) · arraste a janela para cima ou para baixo</p>
          <div data-sem-arraste className="db-lista">
            {!alertas.length ? <div className="db-vazio">Nenhum alerta</div> : alertas.map((al) => (
              <div key={`${al.origem}-${al.id}`} className="db-item press" role="button" tabIndex={0} onClick={() => abrir(al)} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(al) } }}>
                <span className="db-dot" style={{ background: corAlerta(al.tipo), opacity: al.lido ? 0.35 : 1 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <b>{rotuloAlerta(al.tipo)}{al.ativo_nome ? ` · ${al.ativo_nome}` : ''}</b>
                  <div className="db-mini" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fmtHora(al.criado_em)}{al.motorista_nome ? ` · ${al.motorista_nome}` : ''}</div>
                </div>
                <span className="db-mini">{al.lido ? 'lido' : 'novo'} ›</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div key={`det-${atual.origem}-${atual.id}`} className={`db-vista ${dir}`}>
          <button className="db-link" type="button" onClick={voltar}>‹ Alertas</button>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', marginTop: '.4rem' }}>
            <div>
              <div className="db-mini" style={{ color: corAlerta(atual.tipo), fontWeight: 650, textTransform: 'uppercase' }}>{rotuloAlerta(atual.tipo)}</div>
              <h3 style={{ margin: '.1rem 0', fontSize: '1.4rem', letterSpacing: '-.02em' }}>{atual.ativo_nome || 'Veículo'}{atual.placa && atual.placa !== atual.ativo_nome ? ` · ${atual.placa}` : ''}</h3>
              <div className="db-mini">{fmtHora(atual.criado_em)}</div>
            </div>
            <button className="db-btn press" type="button" onClick={aoFechar}>Fechar</button>
          </div>
          {atual.assunto && <p style={{ margin: '.8rem 0 0', fontSize: '.9375rem' }}>{atual.assunto}</p>}
          <div className="db-dados">
            <div><b>Motorista</b>{atual.motorista_nome || 'Não identificado'}</div>
            <div><b>Velocidade</b>{atual.velocidade != null && atual.velocidade !== '' ? `${Math.round(Number(atual.velocidade))} km/h` : '—'}</div>
            <div><b>Ignição</b>{atual.ignicao == null ? '—' : atual.ignicao ? 'Ligada' : 'Desligada'}</div>
            <div><b>Local</b>{atual.endereco || '—'}</div>
          </div>
          {atual.latitude && atual.longitude && (
            <a className="db-btn pri press" style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }} href={`https://maps.google.com/?q=${atual.latitude},${atual.longitude}`} target="_blank" rel="noreferrer">Ver no mapa</a>
          )}
          {atual.lido_em && <div className="db-mini" style={{ marginTop: '.8rem' }}>Lido em {fmtHora(atual.lido_em)}</div>}
        </div>
      )}
    </>
  )
}

export default function AlertasFolha({ aberta, aoFechar, alertas, naoLidos, abrirNoAlerta, aoLer, aoLerTodos }: Props) {
  const [sel, setSel] = useState<any>(null)
  const [dir, setDir] = useState<'avanca' | 'volta'>('volta')
  // ao abrir direto num alerta (toque na lista de "Últimos alertas") mostra o detalhe; ao abrir pelo cartão, a lista
  useEffect(() => { if (aberta) { setDir('avanca'); setSel(abrirNoAlerta || null); if (abrirNoAlerta && !abrirNoAlerta.lido) aoLer(abrirNoAlerta) } /* eslint-disable-next-line */ }, [aberta, abrirNoAlerta])

  const abrir = async (al: any) => { setDir('avanca'); setSel(al); if (!al.lido) await aoLer(al) }
  const voltar = () => { setDir('volta'); setSel(null) }
  // o item aberto acompanha a lista atualizada (lido, etc.)
  const atual = sel ? alertas.find((x) => x.origem === sel.origem && String(x.id) === String(sel.id)) || sel : null

  return (
    <FolhaArrastavel aberta={aberta} aoFechar={aoFechar} rotulo="Alertas">
      <ConteudoAlertas alertas={alertas} naoLidos={naoLidos} atual={atual} dir={dir} abrir={abrir} voltar={voltar} aoFechar={aoFechar} aoLerTodos={() => aoLerTodos()} />
    </FolhaArrastavel>
  )
}
